export default "__VITE_ASSET__DATcLA73__"